module.exports = __webpack_public_path__ + "static/media/sBTC-logo.3981aabd.png";